const SSO_REDIRECT_KEY = "sso_redirect_path";

/** Persist the current `?redirect=` query param so it survives the SSO round-trip. */
export const saveSsoRedirectPath = () => {
  const path = new URLSearchParams(window.location.search).get("redirect");
  if (path) {
    sessionStorage.setItem(SSO_REDIRECT_KEY, path);
  }
};

/** Read and remove the saved redirect path (one-time consumption). */
export const consumeSsoRedirectPath = (): string | null => {
  const path = sessionStorage.getItem(SSO_REDIRECT_KEY);
  if (path) {
    sessionStorage.removeItem(SSO_REDIRECT_KEY);
  }
  return path;
};
